import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App.tsx";
import { preloadRoute } from "@/components/routing/routeTable";
import { setHydrating } from "@/lib/hydration";
import "./index.css";

const container = document.getElementById("root")!;
const normalizePath = (path: string) => path.replace(/\/+$/, "") || "/";

function renderFresh() {
  container.textContent = "";
  createRoot(container).render(<App />);
}

// Marketing pages arrive as pre-built HTML (scripts/ssg.mjs) stamped with the path they
// were built for. Hydrate them in place; anything else renders from scratch.
const prebuiltPath = container.getAttribute("data-prebuilt");
if (prebuiltPath && container.firstElementChild && prebuiltPath === normalizePath(window.location.pathname)) {
  preloadRoute(prebuiltPath).then(
    () => {
      setHydrating(true);
      hydrateRoot(container, <App prebuilt />);
    },
    renderFresh,
  );
} else {
  renderFresh();
}
